module.exports = __webpack_public_path__ + "img/average_pic.60939fa7.png";